import React from 'react'
import ProductJackets from './ProductsJackets'

const Jackets = () => {
  return (
    <>
    <ProductJackets/>
    
    
    </>
  )
}

export default Jackets